import apiService, { defaultHeaders } from './apiService';

export async function getAll () {
  const stores = await apiService.request('/datastore/', {
    headers: defaultHeaders,
    method: 'get',
  });
  return stores.data.results;
}

export async function get (key) {
  const store = await apiService.request(`/datastore/${key}/`, {
    headers: defaultHeaders,
    method: 'get',
  });
  return store.data;
}

export async function create (key, data) {
  const store = await apiService.request(`/datastore/${key}/`, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify(data),
  });
  return store;
}

export async function update (key, data) {
  try {
    const newStore = await apiService.request(`/datastore/${key}/`, {
      headers: defaultHeaders,
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return newStore;
  } catch (e) {
    return create(key, data);
  }
}

export async function remove (key) {
  await apiService.request(`/datastore/${key}/`, {
    headers: defaultHeaders,
    method: 'DELETE',
  });
  return true;
}

export default { getAll, get, update, create };



// WEBPACK FOOTER //
// ./src/services/datastore.js